var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 21.875,
    cy: 21,
    r: 21,
    fill: "#34C759"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4359 25.4233V11H14.4754C13.0602 11 11.9089 12.1513 11.9089 13.5665V26.2383C12.4968 25.7311 13.2614 25.4233 14.097 25.4233H15.4359V25.4233Z",
    fill: "#34C759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4209 20.959C27.547 20.959 27.6721 20.9636 27.7961 20.9719V11H16.6056V25.4233H21.9472C22.4683 22.8788 24.7246 20.959 27.4209 20.959ZM20.1556 14.4442H24.0704V15.6139H20.1556V14.4442ZM18.8332 16.9836H25.3928V18.1534H18.8332V16.9836Z",
    fill: "#34C759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5979 29.3625H14.8731V28.1927H22.0819C21.9218 27.6749 21.8351 27.1252 21.8341 26.5557H14.097C12.8718 26.5557 11.875 27.5524 11.875 28.7776C11.875 30.0028 12.8718 30.9995 14.097 30.9995H24.0523C23.4668 30.5556 22.9712 29.9991 22.5979 29.3625Z",
    fill: "#34C759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4209 22.0918C24.9649 22.0918 22.9668 24.0899 22.9668 26.5459C22.9668 29.0019 24.9649 31 27.4209 31C29.8769 31 31.875 29.0019 31.875 26.5459C31.875 24.0899 29.8769 22.0918 27.4209 22.0918ZM27.4205 23.8794C27.749 23.8794 27.9922 24.1479 28.0064 24.4653C28.0206 24.7818 27.727 25.0512 27.4205 25.0512C27.092 25.0512 26.8488 24.7828 26.8346 24.4653C26.8204 24.1489 27.114 23.8794 27.4205 23.8794ZM28.0078 28.8295H26.8359V25.8295H28.0078V28.8295Z",
    fill: "#34C759"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11.875 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPayment);
export default __webpack_public_path__ + "static/media/ic_payment.1c6059aab33f354214a811e98a66e9c0.svg";
export { ForwardRef as ReactComponent };